import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
};

const ModalConfirm = ({ openModalFun, openModal, closeModalFun, language }) => {
  let subtitle;

  function afterOpenModal() {
    subtitle.style.color = "#f00";
  }
  const SessionExpired =
    language.indexOf("ar") >= 0 ? "انتهت المحادثة" : "Session Expired";
  const SessionExpiredBtn = language.indexOf("ar") >= 0 ? " تأكيد" : "Confirm";

  return (
    <div>
      {/* <button onClick={openModalFun}>Open Modal</button> */}
      <Modal
        isOpen={openModal}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModalFun}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          style={{ color: "#EE3E43", textAlign: "center" }}
        >
          {" "}
          {SessionExpired}
        </h2>
        <button
          style={{
            padding: "5px 20px",
            borderRadius: "5px",
            border: "unset",
            color: "white",
            backgroundColor: "#EE3E43",
            textAlign: "center",
            margin: "auto",
          }}
          onClick={closeModalFun}
        >
          {SessionExpiredBtn}
        </button>
        {/* <div>
          Are you Sure you want to Close the chat or Renew the Session ?
        </div> */}
      </Modal>
    </div>
  );
};
export default ModalConfirm;
